import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerComplaintService = {
  async getByCode(complaintCode) {
    return await ApiService.get(`api/Complaint/${complaintCode}`);
  },

  async save(payload) {
    return await ApiService.post("api/Save_Complaint", payload);
  },

  async updateStatus(payload) {
    return await ApiService.post("api/Update_ComplaintStatus", payload);
  },
};

export { CustomerComplaintService };
